module.exports = __webpack_public_path__ + "img/self-exclusion.6460075f.png";